export default "__VITE_ASSET__5dd2d452__"